import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, Output, EventEmitter, AfterViewInit, HostListener} from '@angular/core';
import {Warehouse, Warehouse1} from '../../project/warehouse';
import {Frame1Component} from '../frames/frame1.component';
import * as d3 from 'd3';


@Component({
  selector: 'app-miniframe1',
  templateUrl: './miniframe.component.html'
})
export class Miniframe1Component extends Frame1Component implements OnInit,  OnChanges, AfterViewInit {

  @Input() selected: string;
  @Output() miniselected = new EventEmitter<string>();
  @Input() stressModal: boolean;

  margin = {top: 5, right: 5, bottom: 5, left: 5};
  color_unselected = "#68a2ff";
  color_selected = "#6fd791";

  constructor(el: ElementRef) {
    super(el);
    this.div = "#miniframe";
    this.radio = 5;
  }

  ngOnInit(){
    this.width = 420 - this.margin.left - this.margin.right;
    this.height = 250 - this.margin.top - this.margin.bottom;
    this.initFrame();
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.selected && changes.selected.previousValue != changes.selected.currentValue){
      this.selectBar();
    }
    if(changes.stressModal && changes.stressModal.firstChange){
      setTimeout(() => {
        this.reDraw();
      }, 300);
    }
  }

  ngAfterViewInit(){
  }

  initFrame(){
    this.prepareData();
    this.createFrame();
    this.addClick();
    this.selectBar();
  }

  addClick(){
    this.svg.selectAll(".line").on("mouseover", function(d){
      d3.select(this).style("stroke-width", 8).style("cursor", "pointer");
    }).on("mouseleave", function(d){
      d3.select(this).style("stroke-width", 5);
    })

    this.svg.selectAll(".l1").on("click", () => {
      this.selected = "1";
      this.selectBar();
      this.miniselected.emit("1");
    });
    this.svg.selectAll(".l2").on("click", () => {
      this.selected = "2";
      this.selectBar();
      this.miniselected.emit("2");
    });
    this.svg.selectAll(".l3").on("click", () => {
      this.selected = "3";
      this.selectBar();
      this.miniselected.emit("3");
    });
    this.svg.selectAll(".l4").on("click", () => {
      this.selected = "4";
      this.selectBar();
      this.miniselected.emit("4");
    });

  }

  selectBar(){
    if(this.svg) this.svg.selectAll(".line").style("stroke-width", 5).style("stroke", this.color_unselected);
    if(this.selected == "1" && this.svg) this.svg.select(".l1").style("stroke", this.color_selected);
    if(this.selected == "2" && this.svg) this.svg.select(".l2").style("stroke", this.color_selected);
    if(this.selected == "3" && this.svg) this.svg.select(".l3").style("stroke", this.color_selected);
    if(this.selected == "4" && this.svg) this.svg.select(".l4").style("stroke", this.color_selected);
  }

}



// WEBPACK FOOTER //
// ./src/app/sketch/miniframes/miniframe1.component.ts